
export default {
    props: [
        'title',
        'intro',
        'image',
        "slug",
        "category_slug",
    ]
}
